module.exports = __webpack_public_path__ + "img/497.99d14241.jpg";